import { ExternalLinkIcon } from '@heroicons/react/solid';
import React from 'react'
import MainButton from 'components/MainButton'

export default function CardDownloadDocument({label,title,date,writer,href,fileName,onClick}) {
  return (
    <div className="justify-between px-5 border xl:flex donwloadWrapper rounded-2xl border-primary py-7">
      <div className="mainWrapper">
        <h1 className="font-medium title text-uppercase text-primary">
          {title}
        </h1>
        <div className="flex items-center justify-between mt-3 text-xs xl:font-normal cardFooter text-cardText ">
          <div className="flex space-x-2">
            <span>{date?.substring(0, 10).split("-").reverse().join("-")}</span>
            <div className="line">|</div>
            <span>{writer}</span>
          </div>
          <ExternalLinkIcon className="hidden w-6 h-6 transition-all duration-300 text-primary group-hover:block" />
        </div>
      </div>
      <div className="flex mt-5 wrapperButton xl:mt-0">
        <MainButton
          label="Download"
          secondType
          download
          href={href}
          filename={fileName}
          onClick={onClick}
        />
      </div>
    </div>
  );
}
